import React, { Component } from "react";

class CustomCheckbox extends Component {
  render() {
    const { label, isChecked, onChange } = this.props;

    return (
      <div className="custom-checkbox">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          id={label}
        />
        <label htmlFor={label}>
          <span className="checkbox-custom">
            {isChecked && (
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 16 16"
                className="bi bi-check"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10.854 4.646a.5.5 0 0 1 .708.708L7.707 9.207a.5.5 0 0 1-.707 0L4.646 6.854a.5.5 0 1 1 .707-.708L7 8.293l3.146-3.147z"
                />
              </svg>
            )}
          </span>
          {label}
        </label>
        <style>{`
          .custom-checkbox {
            display: flex;
            align-items: center;
          }
          input[type="checkbox"] {
            display: none;
          }
          .checkbox-custom {
            width: 20px;
            height: 20px;
            background: white;
            border: 2px solid #ff4314;
            border-radius: 4px;
            display: inline-block;
            cursor: pointer;
            margin-right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          input[type="checkbox"]:checked + label .checkbox-custom {
            background: #ff4314;
            border-color: #ff4314;
          }
          label {
            display: flex;
            align-items: center;
            cursor: pointer;
            user-select: none;
          }
        `}</style>
      </div>
    );
  }
}

export default CustomCheckbox;
